import { requestWrapper } from '@/util/util';
import { getOSSSign, uploadImage } from '@/api/basic/aliyunoss';

/**
 * [{key: 'xxxx', file: file}]
 * @param {*} files
 */
async function uploadFiles(files) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const signResponse = await requestWrapper(getOSSSign)
    if (signResponse.ok === false) {
      reject(new Error('获取签名失败'));
      return;
    }

    const promises = files.map(async (item) => {
      const ossFormData = new FormData();
      ossFormData.append('key', item.key);
      ossFormData.append('signature', signResponse.data.signature);
      ossFormData.append('policy', signResponse.data.policy);
      ossFormData.append('OSSAccessKeyId', signResponse.data.accessKeyId);
      ossFormData.append('success_action_status', '200');
      ossFormData.append('file', item.file);
      return requestWrapper(uploadImage, signResponse.data.host, ossFormData);
    });

    const response = await Promise.all(promises);
    for (let i = 0; i < response.length; i += 1) {
      const result = response[i];
      if (result.ok === false) {
        console.error(result);
        reject(new Error('上传失败'));
        return;
      }
    }

    resolve(files.map((item) => ({
      ...item,
      fileUrl: `${signResponse.data.cdnHost || signResponse.data.host}/${item.key}`,
    })));
  });
}

export default {
  uploadFiles,
};
